module.exports = __webpack_public_path__ + "static/media/Routine-white.45760e4f.svg";